import { render } from "./HireAction.vue?vue&type=template&id=2087e992"
import script from "./HireAction.vue?vue&type=script&lang=js"
export * from "./HireAction.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/HR/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__